(function () {
  'use strict';

  var env = (window.Zwift && window.Zwift.publicEnv) || {};
  var user = (window.Zwift && window.Zwift.user) || {};

  /**
   * Build a full ZWC URL from a path segment.
   * @param {string} path - e.g., 'sign-in', 'logout', 'billing/membership'
   * @param {Object} [opts] - Optional query parameters
   * @param {boolean} [opts.addOrigin] - Append origin=shopify
   * @param {string} [opts.redirectUri] - Append redirect_uri param
   * @returns {string} Full URL, e.g., 'https://www.zwift.com/eu/sign-in?origin=shopify'
   */
  function buildMembersUrl(path, opts) {
    var base = (env.MEMBERS_URL || '').replace(/\/+$/, '');
    if (!path) return base;
    var cleanPath = path.replace(/^\/+/, '');
    var url = base + '/' + cleanPath;

    var params = [];
    if (opts && opts.addOrigin) {
      params.push('origin=shopify');
    }
    if (opts && opts.redirectUri) {
      params.push('redirect_uri=' + encodeURIComponent(opts.redirectUri));
    }
    if (params.length > 0) {
      url += '?' + params.join('&');
    }
    return url;
  }

  var MEMBERS_LINK_REGEX = /\/~MEMBERS~(.+)$/;

  /**
   * Transform all /~MEMBERS~/{path} links in the DOM to full ZWC URLs.
   * Adds origin=shopify to match main branch behavior.
   */
  function transformMembersLinks() {
    var links = document.querySelectorAll('a[href*="/~MEMBERS~/"]');
    for (var i = 0; i < links.length; i++) {
      var href = links[i].getAttribute('href');
      var match = MEMBERS_LINK_REGEX.exec(href);
      if (match && match[1]) {
        links[i].setAttribute(
          'href',
          buildMembersUrl(match[1], { addOrigin: true })
        );
      }
    }
  }

  var RECHARGE_PORTAL_REGEX = /^\/tools\/recurring\//i;

  /**
   * Redirect Recharge customer portal pages to ZWC billing.
   */
  function customerPortalGuard() {
    if (RECHARGE_PORTAL_REGEX.test(window.location.pathname)) {
      window.location.assign(buildMembersUrl('billing/membership', { addOrigin: true }));
    }
  }

  /**
   * Cross-domain auth sync via hidden iframe.
   * If user is not logged in and not on checkout, loads ZWC auth sync page.
   */
  function authSync() {
    var isCheckout = !!(window.Shopify && window.Shopify.Checkout);
    if (isCheckout || user.isLoggedIn) return;

    var iframe = document.createElement('iframe');
    iframe.style.display = 'none';
    iframe.src = buildMembersUrl('shopify-auth-sync.html');
    document.body.appendChild(iframe);
  }

  // Expose for testing and external use
  window.ZwiftAuth = {
    buildMembersUrl: buildMembersUrl,
    transformMembersLinks: transformMembersLinks,
    customerPortalGuard: customerPortalGuard,
    authSync: authSync,
  };

  // --- Auto-initialization ---
  // Guards run immediately (before DOMContentLoaded)
  customerPortalGuard();

  // DOM-dependent functions run when ready
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () {
      transformMembersLinks();
      authSync();
    });
  } else {
    transformMembersLinks();
    authSync();
  }
})();
